import type { TFunction } from "i18next";

import { formatDateTime } from "../../../lib/datetime/displayDateTime";

export const getAnomalyGuideCols = (t: TFunction) => [
  {
    name: t("anomalyGuides.cols.category"),
    selector: (row: { category?: string }) => row.category,
    sortable: true,
  },
  {
    name: t("anomalyGuides.cols.subcategory"),
    selector: (row: { subCategory?: string }) => row.subCategory,
    sortable: true,
  },
  {
    name: t("anomalyGuides.cols.createdBy"),
    selector: (row: { createdBy?: string }) => row.createdBy || "",
    sortable: true,
  },
  {
    name: t("anomalyGuides.cols.createdDate"),
    selector: (row: { createdDate?: string }) =>
      row.createdDate ? formatDateTime(row.createdDate) : "",
    sortable: true,
  },
];

const AnomalyGuideModel = {
  get cols() {
    return getAnomalyGuideCols(((key: string) => key) as TFunction);
  },
  createDialogOpts: (t: TFunction) => ({
    submitButtonText: t("common.create"),
    cancelButtonText: t("common.cancel"),
    title: t("anomalyGuides.createTitle"),
    content: t("anomalyGuides.createContent"),
  }),
  editDialogOpts: (t: TFunction) => ({
    submitButtonText: t("common.update"),
    cancelButtonText: t("common.cancel"),
    title: t("anomalyGuides.editTitle"),
    content: t("anomalyGuides.editContent"),
  }),
  viewDialogOpts: (t: TFunction) => ({
    submitButtonText: t("anomalyGuides.createAnomaly"),
    cancelButtonText: t("common.close"),
    title: t("anomalyGuides.viewTitle"),
    content: t("anomalyGuides.viewContent"),
  }),
  WARNING: { color: "warning", icon: "warning", title: "", content: "", info: "" },
  ERROR: { color: "error", icon: "error", title: "", content: "", info: "" },
  SUCCESS: { color: "success", icon: "success", title: "", content: "", info: "" },
  async message(type: any, title: any, content: any, info: any) {
    return new Promise((resolve) => {
      type.title = title;
      type.content = content;
      type.info = info;
      resolve(type);
    });
  },
};

export default AnomalyGuideModel;
